const normalizeWhitespace = (value: string) => value.trim().replace(/\s+/g, ' ');

const hasLetters = (value: string) => /[A-Za-z]/.test(value);

const isAllCapsLetters = (value: string) => {
  const lettersOnly = value.replace(/[^A-Za-z]/g, '');
  return lettersOnly.length > 0 && lettersOnly === lettersOnly.toUpperCase();
};

const isAllLowercaseLetters = (value: string) => {
  const lettersOnly = value.replace(/[^A-Za-z]/g, '');
  return lettersOnly.length > 0 && lettersOnly === lettersOnly.toLowerCase();
};

const isRomanNumeral = (value: string) => /^[IVXLCDM]+$/i.test(value);

const capitalizeToken = (value: string) => {
  if (!value) return value;
  if (isRomanNumeral(value)) return value.toUpperCase();
  return `${value.charAt(0).toUpperCase()}${value.slice(1).toLowerCase()}`;
};

export const toTitleCase = (value: string) =>
  value
    .split(' ')
    .filter(Boolean)
    .map((word) =>
      word
        .split('-')
        .map((hyphenPart) =>
          hyphenPart
            .split("'")
            .map((apostrophePart) => capitalizeToken(apostrophePart))
            .join("'")
        )
        .join('-')
    )
    .join(' ');

export const toTitleCaseIfAllCaps = (value: string | null | undefined) => {
  const normalized = normalizeWhitespace(value ?? '');
  if (!normalized) return '';
  if (!hasLetters(normalized)) return normalized;
  if (!isAllCapsLetters(normalized) && !isAllLowercaseLetters(normalized)) {
    return normalized;
  }
  return toTitleCase(normalized);
};

export const formatPersonName = (value: string | null | undefined) => toTitleCaseIfAllCaps(value);
